import { render } from "./TextareaTag.vue?vue&type=template&id=3a3a39c1&ts=true"
import script from "./TextareaTag.vue?vue&type=script&lang=ts"
export * from "./TextareaTag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__